import { render, staticRenderFns } from "./PatientSmsWidget.vue?vue&type=template&id=2a8dbacc&scoped=true"
import script from "./PatientSmsWidget.vue?vue&type=script&lang=js"
export * from "./PatientSmsWidget.vue?vue&type=script&lang=js"
import style0 from "./PatientSmsWidget.vue?vue&type=style&index=0&id=2a8dbacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dbacc",
  null
  
)

export default component.exports